import * as EditScreenListLinkType from "../../constants/EditScreenListLinkType";
import {JSCriteriaBuilder} from "../../common/JSCriteriaBuilder";
import {toString} from "../../common/FieldTypesUtils";
import * as FieldType from "../../constants/FieldType";
import {findFieldMetadata} from "../../common/Metadata";
import {isEmptyOrNull} from "../../common/NamaCommon";
import {find} from "../../common/HasIDUtil";

export class CriteriaAndQuestionsOverrider {
    constructor(presenter) {
        let that = this;
        that.presenter = presenter;
    }

    overrideCriteria(criteria) {
        let that = this;
        if (!that.presenter.block || that.presenter.block.linkType !== EditScreenListLinkType.CriteriField || !that.presenter.embeddedListViewSrcRecord)
            return criteria;
        let criteriaBuilder = new JSCriteriaBuilder();
        criteriaBuilder.field(that.presenter.block.linkFieldId).equal(that.presenter.embeddedListViewSrcRecord.id);
        return criteriaBuilder.build().join(criteria);
    }

    overrideQuestionFields(questionFields, source) {
        let that = this;
        if (!questionFields)
            questionFields = [];
        let block = that.presenter.block;
        if (!block || block.linkType !== EditScreenListLinkType.QuestionField)
            return questionFields;
        let linkFields = that.findLinkedFields(block.linkFieldId, questionFields);
        let overriddenQuestions = block.overriddenQuestions;
        let overriddenQuestionsIds = [];
        if (overriddenQuestions)
            overriddenQuestionsIds = overriddenQuestions.map((e) => e.id)
        for (let i = questionFields.length - 1; i >= 0; i--) {
            if (linkFields.contains(questionFields[i]))
                questionFields.splice(i, 1);
            else if (overriddenQuestionsIds.contains(questionFields[i]))
                questionFields.splice(i, 1);
        }
        if (overriddenQuestions) {
            questionFields.push(...overriddenQuestions);
        }
        if (block.hiddenQuestions) {
            for (let question of block.hiddenQuestions) {
                that.presenter.hideQuestionField(question);
            }
        }
        let newFilled = that.createNewFilledQuestions(block.linkFieldId, source, linkFields);
        linkFields.push(...newFilled);
        if (!that.presenter.embeddedListViewSrcRecord)
            return questionFields;
        let value = null;
        if (block.sourceField) {
            that.readSourceFields(questionFields, block.sourceField, block.linkFieldId);
        }
        else {
            for (let field of linkFields) {
                if (field.id === block.linkFieldId) {
                    value = {
                        "entityType": that.presenter.embeddedListViewSrcRecord.entityType,
                        "id": that.presenter.embeddedListViewSrcRecord.id,
                        "code": that.presenter.embeddedListViewSrcRecord.code,
                        "actualCode": that.presenter.embeddedListViewSrcRecord.actualCode,
                        "altCode": that.presenter.embeddedListViewSrcRecord.altCode,
                        "name1": that.presenter.embeddedListViewSrcRecord.name1,
                        "name2": that.presenter.embeddedListViewSrcRecord.name2,
                    };
                    /**
                     *
                     * @type {namaTypes.DTOFilledQuestionField}
                     */
                    let linkField = {
                        id: block.linkFieldId, value: toString(
                            FieldType.Reference, value), objValue: value
                    };
                    questionFields.push(linkField);
                }
                else {
                    let fieldFinalId = field.id.replace(block.linkFieldId + ".", "");
                    let fieldValue = that.presenter.embeddedListViewSrcRecord[fieldFinalId];
                    let fieldMetadata = findFieldMetadata(fieldFinalId, that.presenter.metaData);
                    let fieldType = null;
                    if (fieldMetadata != null) {
                        fieldType = fieldMetadata.fieldType;
                    }
                    that.presenter.hideQuestionField(field.id);
                    /**
                     *
                     * @type {namaTypes.DTOFilledQuestionField}
                     */
                    let linkField = {
                        id: field.id, value: toString(
                            fieldType, fieldValue), objValue: fieldValue
                    };
                    questionFields.push(linkField);
                }
            }

        }
        return questionFields;
    }

    findLinkedFields(id, questionFields) {
        let that = this;
        let returnedFields = [];
        if (id.contains(",")) {
            let parts = id.split(",");
            for (let qId of parts) {
                returnedFields.push(...that.findLinkedFields(qId, questionFields));
            }
            return returnedFields;
        }

        if (!questionFields)
            return returnedFields;
        let idWithDot = id + ".";
        for (let field of questionFields) {
            let qFieldWithDot = field.id + ".";
            if (qFieldWithDot.startsWith(idWithDot))
                returnedFields.push(field);
        }
        return returnedFields;

    }

    createNewFilledQuestions(sourceId, source, linkFields) {
        let that = this;
        let newFilled = [];
        if (sourceId.contains(",")) {
            let parts = sourceId.split(",");
            for (let part of parts) {
                newFilled.push(...that.createNewFilledQuestions(part, source, linkFields));
            }
            return newFilled;
        }

        if (source == null || isEmptyOrNull(sourceId))
            return newFilled;
        let idWithDot = sourceId + ".";
        for (let field of source) {
            let findField = find(field.id, linkFields);
            if (findField != null)
                continue;
            let qFieldWithDot = field.id + ".";
            if (qFieldWithDot.startsWith(idWithDot))
                newFilled.push({id: field.id, value: null, objValue: null});
        }
        return newFilled;
    }

    readSourceFields(questionFields, sourceField, linkFieldId) {
        let that = this;
        if (sourceField.contains(",")) {
            let sourceFieldParts = sourceField.split(",");
            let linkFieldParts = linkFieldId.split(",");
            for (let i = 0; i < sourceFieldParts.length; i++) {
                that.readSourceFields(questionFields, sourceFieldParts[i], linkFieldParts[i]);
            }
            return;
        }
        let value;
        let sourceValue = that.presenter.embeddedListViewSrcRecord[sourceField];
        if (sourceValue && sourceValue.entityType) {
            value = {
                "entityType": sourceValue.entityType,
                "id": sourceValue.id, "code": sourceValue.code, "actualCode": sourceValue.actualCode,
                "altCode": sourceValue.altCode, "name1": sourceValue.name1, "name2": sourceValue.name2,
            };
            /**
             *
             * @type {namaTypes.DTOFilledQuestionField}
             */
            let linkField = {
                id: linkFieldId, value: toString(
                    FieldType.Reference, value), objValue: value
            };
            questionFields.push(linkField);
        }
        else {
            value = sourceValue;
            let sourceFieldMetadata = findFieldMetadata(sourceField, that.presenter.embeddedListMetaData);
            /**
             *
             * @type {namaTypes.DTOFilledQuestionField}
             */
            let linkField = {
                id: linkFieldId, value: toString(sourceFieldMetadata.fieldType, value), objValue: value
            };
            questionFields.push(linkField);
        }
    }
}